<template>
    <div class="blue-card">
        <router-link :to="{ name: 'Dashboard' }">
            <div class="menu-entry">
                <div class="menu-icon">
                    <img class="menu-image img-content-dashboard" />
                </div>
                <div class="menu-text">
                    <p>Dashboard</p>
                </div>
            </div>
        </router-link>
        <router-link :to="{ name: 'ControlPanelInbox' }">
            <div class="menu-entry">
                <div class="menu-icon">
                    <img class="menu-image image-container2 img-content-73b7da92" />
                </div>
                <div class="menu-text">
                    <p>Inbox</p>
                </div>
                <div class="alert-icon bounce" v-if="hasUnreadEmails">
                    <img class="image-container img-content-380bfb60" />
                </div>
            </div>
        </router-link>
        <router-link :to="{ name: 'ControlPanelMeters' }" v-if="areMetersVisible">
            <div class="menu-entry">
                <div class="menu-icon">
                    <img class="menu-image image-container4"
                        style="content: url('data:image/svg+xml;charset=utf8,%3Csvg%20viewBox%3D%27103.2175%20853.6815%2059.5650%2062.6370%27%20x%3D%270%27%20y%3D%270%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20id%3D%27Icon_4%27%20d%3D%27M105.736%20892.065H139.87M105.736%20892.065L139.695%20892.061C139.754%20892.061%20139.812%20892.062%20139.87%20892.065M105.736%20892.065L105.736%20903.72C105.736%20905.311%20107.348%20906.6%20109.336%20906.6H139.696C141.684%20906.6%20143.296%20905.311%20143.296%20903.72V894.941C143.296%20893.397%20141.777%20892.137%20139.87%20892.065M105.736%20892.065L105.736%20877.525M139.87%20892.065H156.664C158.652%20892.065%20160.264%20890.775%20160.264%20889.185V880.405C160.264%20878.814%20158.652%20877.525%20156.664%20877.525M105.736%20877.525H156.664M105.736%20877.525L105.736%20866.28C105.736%20864.69%20107.348%20863.4%20109.336%20863.4L123.736%20863.4C125.724%20863.4%20127.336%20864.69%20127.336%20866.28V874.645C127.336%20876.235%20125.724%20877.525%20123.736%20877.525L156.664%20877.525M105.736%20913.8V856.2%27%20stroke%3D%27white%27%20stroke-width%3D%275.03704%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%2F%3E%3C%2Fsvg%3E')" />
                </div>
                <div class="menu-text">
                    <p>Meters</p>
                </div>
            </div>
        </router-link>
        <router-link :to="{ name: 'ControlPanelPhone' }" v-if="isPhonebookVisible">
            <div class="menu-entry">
                <div class="menu-icon">
                    <img class="menu-image image-container4"
                        style="content: url('data:image/svg+xml;charset=utf8,%3Csvg%20viewBox%3D%27102.5939%20988.5938%2051.0123%2051.0125%27%20x%3D%270%27%20y%3D%270%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20id%3D%27Icon%27%20d%3D%27M130.196%201000.45C133.083%201000.93%20135.706%201002.29%20137.8%201004.38C139.894%201006.47%20141.249%201009.09%20141.745%201011.97M130.637%20991C135.772%20991.869%20140.456%20994.299%20144.18%20998.005C147.905%201001.72%20150.329%201006.4%20151.2%201011.52M147.189%201031.91C147.189%201031.91%20144.401%201034.65%20143.717%201035.45C142.604%201036.64%20141.293%201037.2%20139.574%201037.2C139.409%201037.2%20139.232%201037.2%20139.067%201037.19C135.794%201036.98%20132.753%201035.7%20130.471%201034.62C124.234%201031.6%20118.757%201027.32%20114.206%201021.9C110.448%201017.38%20107.936%201013.2%20106.272%201008.72C105.247%201005.98%20104.872%201003.84%20105.038%201001.83C105.148%201000.55%20105.644%20999.479%20106.558%20998.566L110.316%20994.816C110.856%20994.31%20111.429%20994.035%20111.991%20994.035C112.685%20994.035%20113.247%20994.453%20113.6%20994.805C113.611%20994.816%20113.622%20994.827%20113.633%20994.838C114.305%20995.465%20114.944%20996.114%20115.617%20996.807C115.958%20997.159%20116.311%20997.51%20116.664%20997.873L119.672%201000.88C120.84%201002.04%20120.84%201003.12%20119.672%201004.28C119.352%201004.6%20119.044%201004.92%20118.724%201005.23C117.799%201006.18%20118.526%201005.45%20117.567%201006.31C117.545%201006.33%20117.523%201006.34%20117.512%201006.36C116.564%201007.31%20116.741%201008.23%20116.939%201008.86C116.95%201008.89%20116.961%201008.93%20116.972%201008.96C117.754%201010.85%20118.856%201012.63%20120.531%201014.75L120.542%201014.77C123.584%201018.5%20126.791%201021.42%20130.328%201023.65C130.78%201023.94%20131.243%201024.17%20131.684%201024.39C132.08%201024.59%20132.455%201024.77%20132.774%201024.97C132.819%201024.99%20132.863%201025.03%20132.907%201025.05C133.281%201025.23%20133.634%201025.32%20133.998%201025.32C134.912%201025.32%20135.485%201024.75%20135.673%201024.56L137.833%201022.41C138.207%201022.03%20138.803%201021.58%20139.497%201021.58C140.18%201021.58%20140.742%201022.01%20141.084%201022.39C141.095%201022.4%20141.095%201022.4%20141.106%201022.41L147.178%201028.47C148.313%201029.59%20147.189%201031.91%20147.189%201031.91Z%27%20stroke%3D%27white%27%20stroke-width%3D%274.8125%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%2F%3E%3C%2Fsvg%3E')" />
                </div>
                <div class="menu-text">
                    <p>Telefoon</p>
                </div>
                <div class="alert-icon bounce" v-if="hasUnreadVoicemails">
                    <img class="image-container img-content-380bfb60" />
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "ControlPanelMenu",
    data() {
        return {
            lastReadStartTime: null,
            lastUnreadCount: 0,
            lastImportantReadStartTime: null,
            lastImportantUnreadCount: 0,
            // Meters and phonebook are disabled since the final v1 update
            areMetersVisible: false,
            isPhonebookVisible: false,
        }
    },
    computed: {
        hasUnreadEmails() {
            if (this.$store.state && this.$store.state.session) {
                const now = new Date().getTime();
                const teamIndex = this.$store.state.team;
                const unreadEmails = this.$store.state.session.steps
                    ? this.$store.state.session.steps.filter(
                        msg =>
                            !msg.isRead
                            && msg.startTime != null
                            && new Date(msg.startTime).getTime() < now
                            && !msg.isVoicemail
                            && (msg.teams && msg.teams.includes(teamIndex))
                    ) : [];
                // console.log(`Unread emails: ${unreadEmails.length}`);
                // console.log(unreadEmails);
                this.showNotification(unreadEmails);
                return unreadEmails.length > 0;
            }
            return 0;
        },
        hasUnreadVoicemails() {
            return false;
            /* const now = new Date().getTime();
            const unreadEmails = this.$store.state && this.$store.state.session && this.$store.state.session.steps
                ? this.$store.state.session.steps.filter(
                    msg =>
                        !msg.isRead
                        && msg.startTime != null
                        && new Date(msg.startTime).getTime() < now
                        && msg.isVoicemail
                ) : [];
            // console.log(`Unread voicemails: ${unreadEmails.length}`);
            // console.log(unreadEmails);
            return unreadEmails.length > 0; */
        },
        // areMetersVisible() {
        //     if (!this.$store.state.session) {
        //         return false;
        //     }
        //     return gametree.areMetersVisible(this.$store.state.session.variant, this.$store.state.session.progress);
        // }
    },
    methods: {
        showNotification(unreadEmails) {
            if (unreadEmails.length > this.lastUnread) {
                let variant = 'primary'
                if (unreadEmails.some(x => x.important)) {
                    variant = 'danger';
                }
                this.$bvToast.toast(`Er is een nieuw bericht in de inbox`, {
                    title: 'Nieuw bericht',
                    autoHideDelay: 6000,
                    variant: variant,
                    solid: true,
                    appendToast: false,
                    // href: `/control-panel/inbox/${unreadEmails[0].dilemmaId}#content`
                    //href: '/control-panel/inbox'
                });
            }

            this.lastUnread = unreadEmails.length;
        }
    }
};
</script>

<style scoped>
.blue-card {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    align-self: stretch;
    justify-content: flex-start;
    /* padding: 1.9375rem 1.28125rem 0.84375rem 1.34375rem; */
    padding: 0 1.2rem;
    background: var(--color-blue);
    /* width: 16rem; */
    /* margin-left: 1.5rem; */
    border-radius: 1.125rem;
    box-shadow: 0rem 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
}

.menu-entry {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding-top: 1.2rem;
    padding-bottom: 1rem;
    cursor: pointer;
}

.router-link-active .menu-icon {
    background-color: #f0f0f047;
    border: 2px solid white;
    border-radius: 50%;
}

.menu-icon {
    border: 2px solid transparent;
    padding: 1rem;
    margin-right: 1rem;
}

a:not(:first-of-type) .menu-entry {
    border-top: 1px solid white;
}

.menu-entry:hover {
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.3), transparent);
}

.router-link-active .menu-text {
    font: 700 1.9rem Roboto;
}

.menu-text {
    margin-left: 1rem;
    font: 500 1.9rem Roboto;
    color: white;
    padding-top: 0.6rem;
}

.menu-image,
.menu-text {
    display: flex;
    align-items: baseline;
}

.alert-icon img {
    margin-left: 1.5rem;
    width: 1.5em !important;
    height: 1.5em !important;
}

.menu-image {
    width: 2.5rem;
    height: 2.5rem;
}

.img-content-73b7da92 {
    content: url("data:image/svg+xml;charset=utf8,%3Csvg%20viewBox%3D%27105.5567%20505.9447%2055.5656%2044.4526%27%20x%3D%270%27%20y%3D%270%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20id%3D%27Icon_5%27%20d%3D%27M113.023%20513.585L131.56%20526.894C132.631%20527.662%20134.048%20527.662%20135.119%20526.894L153.656%20513.585M114.586%20547.619H152.093C155.545%20547.619%20158.344%20544.717%20158.344%20541.137V515.206C158.344%20511.626%20155.545%20508.723%20152.093%20508.723H114.586C111.134%20508.723%20108.335%20511.626%20108.335%20515.206V541.137C108.335%20544.717%20111.134%20547.619%20114.586%20547.619Z%27%20stroke%3D%27white%27%20stroke-width%3D%275.55658%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%2F%3E%3C%2Fsvg%3E");
}

.img-content-dashboard {
    content: url("@/assets/ic_menu_dashboard.png");
}

.img-content-380bfb60 {
    content: url("data:image/svg+xml;charset=utf8,%3Csvg%20viewBox%3D%27314.8335%20510.7501%2038.3331%2034.4996%27%20x%3D%270%27%20y%3D%270%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20id%3D%27Icon_6%27%20d%3D%27M334%20529.725V521.128M334%20536.097V536.173M344.867%20543.333H323.133C320.164%20543.333%20317.658%20541.371%20316.87%20538.687C316.534%20537.541%20316.947%20536.347%20317.579%20535.331L328.447%20515.735C330.993%20511.644%20337.007%20511.644%20339.553%20515.735L350.421%20535.331C351.053%20536.347%20351.466%20537.541%20351.13%20538.687C350.342%20541.371%20347.836%20543.333%20344.867%20543.333Z%27%20stroke%3D%27white%27%20stroke-width%3D%273.83333%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%2F%3E%3C%2Fsvg%3E");
}

.img-content-d9e8c39b {
    content: url("data:image/svg+xml;charset=utf8,%3Csvg%20viewBox%3D%27108.2952%20621.2969%2049.9009%2049.9014%27%20x%3D%270%27%20y%3D%270%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20id%3D%27Icon_3%27%20d%3D%27M154.596%20624.897L129.495%20649.999M112.699%20637.386L151.787%20623.825C154.194%20622.99%20156.503%20625.299%20155.668%20627.707L142.107%20666.794C141.178%20669.472%20137.418%20669.545%20136.385%20666.906L130.178%20651.044C129.868%20650.252%20129.242%20649.625%20128.449%20649.315L112.588%20643.108C109.948%20642.075%20110.022%20638.315%20112.699%20637.386Z%27%20stroke%3D%27white%27%20stroke-width%3D%274.70766%27%20stroke-linecap%3D%27round%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%2F%3E%3C%2Fsvg%3E");
}
</style>
